// Copyright (c) Docugami, Inc. All rights reserved.

import { ProviderId } from "networking/StorageProviders";
import { useMemo } from "react";
import { getProviderFriendlyName } from "storage/StorageProviderHelpers";

export interface FormattedPath {
    providerString: string;
    directoryPath: string;
}

export interface FormattedPathProps {
    providerId?: ProviderId;
    destinationPath?: string;
    separatorString: string;
}

export function useFormattedPath(props: FormattedPathProps): FormattedPath {
    const formattedPath: FormattedPath = useMemo(() => {
        if (!props.destinationPath || !props.providerId) {
            return { providerString: '', directoryPath: '' };
        }

        let destinationPath = props.destinationPath;
        if (destinationPath.startsWith('/')) {
            destinationPath = destinationPath.substring(1);
        }

        if (destinationPath.endsWith('/')) {
            destinationPath = destinationPath.substring(0, destinationPath.length - 2);
        }

        const content = destinationPath.replaceAll('/', props.separatorString);

        return {
            providerString: getProviderFriendlyName(props.providerId) + props.separatorString,
            directoryPath: content
        };
    }, [props.providerId, props.destinationPath, props.separatorString]);

    return formattedPath;
}
